import { render } from "./contactus.vue?vue&type=template&id=7ff5e624"
import script from "./contactus.vue?vue&type=script&lang=js"
export * from "./contactus.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/aghaietv-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__